import React from 'react';
import { CampaignByIdDetailsProps } from './campaignModels';
import {
  DetailsCreatedByIcon,
  DetailsDateIcon,
  DetailsDurationIcon,
  DetailsFavoriteIcon,
  DetailsGoalIcon,
  DetailsPlatformIcon,
} from '../../../assets';
import {
  formatDateToMMMDYYYY,
  getDateRangeInDays,
} from '../../../helpers/dateHelpers';

const CampaignByIdDetails: React.FC<CampaignByIdDetailsProps> = ({
  campaignData,
}) => {
  return (
    <div className="campaign-by-id__details-container">
      <span className="campaign-by-id__details-title">Details</span>
      <div className="campaign-by-id__details-list">
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsFavoriteIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              Status
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {campaignData?.status &&
                campaignData.status.charAt(0) +
                  campaignData.status.slice(1).toLowerCase()}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsGoalIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              Goal
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {campaignData?.goals}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsDurationIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              Duration
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {getDateRangeInDays(
                campaignData?.startDate ?? '',
                campaignData?.endDate ?? ''
              )}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsDateIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              Start date
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {formatDateToMMMDYYYY(campaignData?.startDate ?? '')}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsDateIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              End date
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {formatDateToMMMDYYYY(campaignData?.endDate ?? '')}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsPlatformIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              {campaignData?.platforms && campaignData?.platforms?.length > 1
                ? 'Platforms'
                : 'Platform'}
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {campaignData?.platforms?.join(', ')}
            </span>
          </div>
        </div>
        <div className="campaign-by-id__details-outline"></div>
        <div className="campaign-by-id__details-item">
          <div className="campaign-by-id__details-icon">
            <DetailsCreatedByIcon />
          </div>
          <div className="campaign-by-id__details-item-content">
            <span className="campaign-by-id__details-item-content-label">
              Created by
            </span>
            <span className="campaign-by-id__details-item-content-value">
              {campaignData?.agent?.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignByIdDetails;
